import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { tv, type VariantProps } from 'tailwind-variants';

const callout = tv({
  base: 'rounded-lg border text-sm',
  variants: {
    variant: {
      info: 'border-blue-200 bg-blue-50 text-blue-900',
      warning: 'border-yellow-200 bg-yellow-50 text-yellow-900',
      danger: 'border-red-500/50 bg-red-50 text-red-600',
      success: 'border-green-200 bg-green-50 text-green-900',
    },
    inline: {
      true: 'inline-flex items-center gap-2 border-none px-4 py-3 font-medium',
      false: 'w-full p-4',
    },
  },
  defaultVariants: {
    variant: 'info',
    inline: false,
  },
});

type CalloutProps = VariantProps<typeof callout> & {
  children: React.ReactNode;
  className?: string;
};

export const Callout = ({
  children,
  variant = 'info',
  inline = false,
  className,
}: CalloutProps) => {
  if (inline) {
    return (
      <div
        role="status"
        aria-live="polite"
        className={callout({ variant, inline, className })}
      >
        <InformationCircleIcon className="size-5 shrink-0" />
        <span>{children}</span>
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={callout({ variant, inline, className })}
    >
      <div className="flex">
        <InformationCircleIcon className="mr-2 mt-0.5 size-4 shrink-0" />
        <div>{children}</div>
      </div>
    </div>
  );
};
